import { render, staticRenderFns } from "./AddResourcePriceModal.vue?vue&type=template&id=65e58775&"
import script from "./AddResourcePriceModal.vue?vue&type=script&lang=js&"
export * from "./AddResourcePriceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourcePriceModal.vue?vue&type=style&index=0&id=65e58775&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports